import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import customDataReducer from "@tKgpco/Store/Data/CustomDataReducer";

(reducers as any).KGPState = customDataReducer;

type Reducers = {
    KGPState: typeof customDataReducer;
};

export type CustomActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
